module.exports = __webpack_public_path__ + "img/Weapon_25.89a134d2.png";